// src/pages/QuotesPageContainer.js
import React, { useState, useEffect } from "react";
import api from "../api";
import QuotesPage from "./MyQuote";

const QuotesPageContainer = () => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuotes = async () => {
      try { 
        const res = await api.get("/api/my-quotes"); // adjust API endpoint
        setQuotes(res.data || []);
      } catch (err) {
        console.error("Failed to fetch quotes:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchQuotes();
  }, []);

  if (loading) return <div className="text-center py-5">Loading quotes...</div>;

  return <QuotesPage quotes={quotes} />;
};

export default QuotesPageContainer;
